import React, {useEffect, useState} from 'react';
import {Avatar, Modal, Skeleton} from "antd";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

function LightBox({photos, id, loading = false}) {
    const [images, setImages] = useState([])
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        setImages(photos)
    }, [photos]);

    const handlePrev = () => {
        setCurrentImageIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : 0));
    };

    const handleNext = () => {
        setCurrentImageIndex(prevIndex => (prevIndex < images.length - 1 ? prevIndex + 1 : images.length - 1));
    };

    const handleKeyDown = (event) => {
        if (visible) {
            if (event.key === 'ArrowLeft' && currentImageIndex !== 0) {
                handlePrev();
            } else if (event.key === 'ArrowRight' && currentImageIndex !== images.length - 1) {
                handleNext();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImageIndex, visible, images]);

    return (
        <>
            <Avatar shape="square" size={45} icon="file-image" src={images && images[0] && images[0]['url']}
                    alt={images && images[0] && images[0]['name']} style={{cursor: 'pointer'}}
                    onClick={() => setVisible((images && images[0] && images[0]['name']) ? true : false)}/>
            <Modal visible={visible} onCancel={() => setVisible(false)} footer={null} centered
                   title={null}
                   bodyStyle={{padding: 0}}
                   width="70%"
            >
                <div style={{
                    position: 'relative',
                    backgroundColor: 'black',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // height: '100%',
                    // width: '100%'
                }}>
                    {currentImageIndex !== 0 && (
                        <LeftOutlined
                            style={{
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: 'white',
                                fontSize: '24px', // Adjust the size of the icon
                                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)', // Add a shadow
                                cursor: 'pointer',
                                zIndex: 1000,
                            }}
                            onClick={handlePrev}
                        />
                    )}
                    {loading ? <Skeleton active/> :
                        <img alt="preview" src={images && images[currentImageIndex] && images[currentImageIndex]['url']}
                             style={{
                                 position: 'relative',
                                 width: 'auto',
                                 height: 'auto',
                                 display: 'block',
                                 maxHeight: '70vh', // Adjust max height as needed
                                 maxWidth: '90%',
                                 margin: '0 auto',
                                 // maxHeight: '80vh', // Adjust height as needed
                                 // maxWidth: '60vw', // Adjust width as needed
                                 // objectFit: 'contain',
                             }}/>
                    }
                    {currentImageIndex !== images.length - 1 && (
                        <RightOutlined
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: 'white',
                                fontSize: '24px', // Adjust the size of the icon
                                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)', // Add a shadow
                                cursor: 'pointer',
                                zIndex: 1000,
                            }}
                            onClick={handleNext}
                        />
                    )}
                </div>
            </Modal>
        </>
    );
}

export default LightBox;
